function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 160,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1433cb",
    d: "M 637.5,-0.5 C 649.833,-0.5 662.167,-0.5 674.5,-0.5C 694.14,1.90696 713.473,6.24029 732.5,12.5C 727.675,34.9584 722.342,57.2918 716.5,79.5C 688.703,66.6957 659.703,62.529 629.5,67C 617.839,69.018 609.339,75.1847 604,85.5C 601.696,93.9284 603.863,101.095 610.5,107C 616.156,111.496 622.156,115.496 628.5,119C 647.479,127.817 665.479,138.15 682.5,150C 711.623,173.377 721.123,203.21 711,239.5C 702.915,264.916 687.415,284.416 664.5,298C 641.225,310.374 616.558,317.541 590.5,319.5C 578.167,319.5 565.833,319.5 553.5,319.5C 530.029,317.571 507.029,312.738 484.5,305C 482.998,304.417 481.665,303.584 480.5,302.5C 485.833,280.167 491.167,257.833 496.5,235.5C 496.833,235.167 497.167,234.833 497.5,234.5C 527.288,250.353 558.954,256.52 592.5,253C 604.829,251.419 615.329,246.252 624,237.5C 631.257,225.158 629.424,214.325 618.5,205C 614.167,202 609.833,199 605.5,196C 588.893,188.365 572.893,179.698 557.5,170C 517.113,142.489 506.946,106.322 527,61.5C 543.625,33.5736 567.792,15.407 599.5,7C 612.111,3.51332 624.778,1.01332 637.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#1433cb",
    d: "M -0.5,15.5 C -0.5,13.5 -0.5,11.5 -0.5,9.5C 0.234419,8.12247 0.901085,6.62247 1.5,5C 48.5,4.33333 95.5,4.33333 142.5,5C 160.86,7.35784 172.36,17.5245 177,35.5C 187.132,94.6273 197.799,153.627 209,212.5C 237.471,143.419 266.138,74.419 295,5.5C 323.767,4.17208 352.601,4.17208 381.5,5.5C 336.608,108.284 291.442,210.951 246,313.5C 216.907,314.495 187.74,314.829 158.5,314.5C 137.985,230.44 117.152,146.44 96,62.5C 93.8439,53.3394 88.6773,46.506 80.5,42C 54.6667,29.6245 27.6667,20.7911 -0.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#1433cb",
    d: "M 415.5,4.5 C 442.833,4.5 470.167,4.5 497.5,4.5C 473.578,107.777 449.911,211.11 426.5,314.5C 398.825,314.833 371.159,314.5 343.5,313.5C 367.665,210.507 391.665,107.507 415.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#1433cb",
    d: "M 999.5,308.5 C 999.5,310.5 999.5,312.5 999.5,314.5C 974.167,314.5 948.833,314.5 923.5,314.5C 921.072,299.194 918.072,284.028 914.5,269C 880.162,268.167 845.828,268.333 811.5,269.5C 805.833,284.167 800.167,298.833 794.5,313.5C 765.506,314.667 736.506,314.833 707.5,314C 750.404,217.691 792.904,121.191 835,24.5C 842.054,12.5509 852.554,6.05095 866.5,5C 890.739,4.17276 914.906,4.33943 939,5.5C 958.744,106.72 978.911,207.72 999.5,308.5 Z M 878.5,92.5 C 879.117,92.6107 879.617,92.944 880,93.5C 887.619,130.429 894.786,167.429 901.5,204.5C 879.823,204.833 858.156,204.5 836.5,203.5C 850.903,166.62 864.903,129.62 878.5,92.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c3941e60e331a12129af0fe8dc32a9a8.svg";
export { ForwardRef as ReactComponent };